var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccessToRealesyMarketplace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 66 66",
    height: 512,
    viewBox: "0 0 66 66",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m65 62.83c0 .6-.24 1.14-.63 1.54-.4.39-.94.63-1.54.63h-59.67c-1.19 0-2.16-.97-2.16-2.17 0-.6.24-1.14.63-1.53.4-.39.94-.63 1.53-.63h59.67c1.2 0 2.17.97 2.17 2.16z",
    fill: "#8c9ffa"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m4.93 18.34h50.38v42.33h-50.38z",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m6.51 30.76c-2.48 0-4.32-2.3-3.77-4.72l2.3-10.12c.4-1.78 1.98-3.04 3.81-3.04h3.85l-2.38 14.63c-.3 1.87-1.91 3.25-3.81 3.25z",
    fill: "#fcd131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.42 30.76h-.08c-2.38 0-4.19-2.13-3.81-4.48l2.17-13.39h6.96l-1.4 14.39c-.19 1.97-1.85 3.48-3.84 3.48z",
    fill: "#fc8068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.31 30.76h-.13c-2.28 0-4.07-1.97-3.84-4.24l1.33-13.64h6.96l-.46 14.14c-.07 2.08-1.77 3.74-3.86 3.74z",
    fill: "#fcd131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.19 30.76h-.15c-2.18 0-3.93-1.81-3.86-3.99l.45-13.89h6.96l.45 13.89c.08 2.18-1.67 3.99-3.85 3.99z",
    fill: "#fc8068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.04 30.76h-.13c-2.08 0-3.79-1.65-3.86-3.74l-.45-14.14h6.96l1.33 13.64c.22 2.27-1.57 4.24-3.85 4.24z",
    fill: "#fcd131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.89 30.76h-.08c-1.99 0-3.65-1.51-3.84-3.49l-1.4-14.39h6.96l2.17 13.39c.38 2.35-1.43 4.49-3.81 4.49z",
    fill: "#fc8068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.71 30.76c-1.89 0-3.51-1.37-3.81-3.24l-2.38-14.63h3.85c1.82 0 3.4 1.26 3.81 3.04l2.3 10.12c.55 2.4-1.29 4.71-3.77 4.71z",
    fill: "#fcd131"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m9.67 4.42h40.88v8.46h-40.88z",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.8 2.71c0 .94-.76 1.71-1.71 1.71h-41.95c-.94 0-1.71-.77-1.71-1.71 0-.95.77-1.71 1.71-1.71h41.95c.95 0 1.71.76 1.71 1.71z",
    fill: "#8c9ffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.6 39.23v21.44h-15.92v-21.44c0-1 .81-1.81 1.81-1.81h12.3c1 0 1.81.81 1.81 1.81z",
    fill: "#44394a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.68 39.23v13.86c0 1-.81 1.81-1.81 1.81h-15c-1 0-1.82-.81-1.82-1.81v-13.86c0-1 .82-1.81 1.82-1.81h15c1 0 1.81.81 1.81 1.81z",
    fill: "#8c9ffa"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#6e7fed"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m41.33 37.42h2.07v17.48h-2.07z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.05 45.13h18.63v2.06h-18.63z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 12.53,
    cy: 50.92,
    fill: "#fff",
    r: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.35 45.31c0 3.64-5 11.56-7.17 14.82-.47.71-1.51.73-2.01.03-2.3-3.24-7.67-11.19-7.67-14.85 0-4.65 3.77-8.42 8.42-8.42s8.43 3.77 8.43 8.42z",
    fill: "#fc8068"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.93,
    cy: 45.31,
    fill: "#ee6a51",
    r: 6.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.93,
    cy: 45.31,
    fill: "#fff",
    r: 4.11
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessToRealesyMarketplace);
export default __webpack_public_path__ + "static/media/access-to-realesy-marketplace.31e927f2a691096b057f1383aaaa56e5.svg";
export { ForwardRef as ReactComponent };